import { PropsWithChildren } from "react";
import styles from "./Pill.module.css";


interface PillProps extends React.DetailedHTMLProps<React.ButtonHTMLAttributes<HTMLButtonElement>, HTMLButtonElement>, React.AriaAttributes {
  preventDefault?: boolean;
  stopPropagation?: boolean;
  checked?: boolean;
}

export default function Pill({ className, children, preventDefault = true, stopPropagation = true, checked = false,...rest }: PropsWithChildren<PillProps>) {

  return (
    <button
        className={`
        ${styles.main}
        ${checked ? styles.checked : ''}
        ${className}
        `}
        {...rest}>
      {children}
    </button>
  );
}
